/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {
    Box,
    useMultiStyleConfig,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ContentAsset from '../../../components/content-asset'
import {useGlobaleContext} from '../../../contexts/globale'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'

const footerSkeleton = () => {
    return <Skeleton width="100%" height="167px" />
}

const CheckoutFooter = () => {
    const styles = useMultiStyleConfig('CheckoutFooter')
    const {countryISO} = useGlobaleContext()
    const {data: basket, isLoading: isBasketLoading} = useCurrentBasket()
    if (!countryISO || (countryISO && countryISO !== 'US') || isBasketLoading || !basket) {
        return footerSkeleton
    }
    return (
        <Box
            as="footer"
            {...styles.container}
            {...styles.footerContent}
            className="footer-container"
        >
            <ContentAsset contentAssetId="checkout-footer" skeleton={footerSkeleton} />
        </Box>
    )
}

export default CheckoutFooter
